import { sqliteTable, text, integer, index, uniqueIndex } from "drizzle-orm/sqlite-core";
import { accounts } from "./accounts";

// ============================================================================
// bank_accounts — company bank-account master linked to a GL asset account
// ============================================================================
export const bankAccounts = sqliteTable("accounting_bank_accounts", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  accountId: text("account_id").notNull().references(() => accounts.id),
  bankName: text("bank_name").notNull(),
  bankBranch: text("bank_branch"),
  accountNo: text("account_no").notNull(),
  accountName: text("account_name").notNull(),
  swiftCode: text("swift_code"),
  currencyCode: text("currency_code").notNull().default("THB"),
  isDefault: integer("is_default").notNull().default(0),
  isActive: integer("is_active").notNull().default(1),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyActiveIdx: index("bank_accounts_company_active_idx").on(table.companyId, table.isActive, table.sortOrder),
  companyBranchIdx: index("bank_accounts_company_branch_idx").on(table.companyId, table.branchId),
  companyGlAccountIdx: index("bank_accounts_company_gl_account_idx").on(table.companyId, table.accountId),
  companyAccountNoUnique: uniqueIndex("bank_accounts_company_account_no_unique").on(table.companyId, table.accountNo),
}));

export type BankAccount = typeof bankAccounts.$inferSelect;
export type NewBankAccount = typeof bankAccounts.$inferInsert;
